import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Card, Button, Empty, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { getExerciseDetailsById, getExercisesByChapter } from '../../services/exerciseService';
import QuestionRenderer from '../../components/QuestionRenderer';
import { useAuth } from '../../context/AuthContext';

const { Title } = Typography;

const ExercisePage = () => {
  const { levelId, chapterId, exerciseId } = useParams();
  const navigate = useNavigate();
  const { userRole } = useAuth();
  const [exercise, setExercise] = useState(null);
  const [loading, setLoading] = useState(true);

  const chapterExercises = useMemo(() => {
    return getExercisesByChapter(levelId, chapterId);
  }, [levelId, chapterId]);

  useEffect(() => {
    setLoading(true);
    const data = getExerciseDetailsById(exerciseId);
    setExercise(data);
    setLoading(false);
  }, [exerciseId]);

  const handleNextQuestion = () => {
    const currentIndex = chapterExercises.findIndex(ex => ex.id === exerciseId);
    if (currentIndex !== -1 && currentIndex < chapterExercises.length - 1) {
      const nextExercise = chapterExercises[currentIndex + 1];
      navigate(`/level/${levelId}/chapter/${chapterId}/exercise/${nextExercise.id}`);
    } else {
      const isStudent = userRole?.name === '学生' || userRole?.name === 'Học sinh';
      const backPath = isStudent ? `/level/${levelId}` : `/level/${levelId}/chapter/${chapterId}`;
      navigate(backPath);
    }
  };

  if (loading) {
    return <Spin size="large" style={{ display: 'block', marginTop: 50 }} />;
  }

  if (!exercise) {
    return <Empty description="課題データが見つかりません。(Không tìm thấy dữ liệu bài tập.)" />;
  }
  
  const isStudent = userRole?.name === '学生' || userRole?.name === 'Học sinh';
  const backPath = isStudent ? `/level/${levelId}` : `/level/${levelId}/chapter/${chapterId}`;

  return (
    <div>
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(backPath)}
        style={{ marginBottom: '16px' }}
      >
        戻る
      </Button>

      <Title level={2}>{exercise.title}</Title>

      {exercise.questions.map((question) => (
        <Card key={question.id} style={{ marginTop: '16px' }}>
          <QuestionRenderer 
            mode="practice"
            question={question} 
            onNextQuestion={handleNextQuestion} 
            exerciseId={exerciseId} 
            levelId={levelId}
            chapterId={chapterId}
          />
        </Card>
      ))}
    </div>
  );
};

export default ExercisePage;